/**
 * Diamond Card 每日奖励 service 层
 *
 * 接口定义见《互动小说 Diamond Card C 端 API 联调说明》(2026-08-25)。
 */
import { api } from '@/api'

/** 领取日历（month 缺省为服务端当前自然月） */
export async function fetchBonusCalendar(month?: string): Promise<DiamondCardCalendarData> {
  const { data } = await api.get<any, { data: DiamondCardCalendarData }>(
    '/interactive/subscription/bonus/calendar',
    { params: month ? { month } : {} },
  )
  return data
}

/**
 * 领取当日奖励
 * @param requestId 幂等 ID，同一次操作重试必须复用原值
 */
export async function claimBonus(requestId: string): Promise<DiamondCardClaimData> {
  const { data } = await api.post<any, { data: DiamondCardClaimData }>(
    '/interactive/subscription/bonus/claim',
    { requestId },
  )
  return data
}

/** Rewards Tab 红点状态（免费签到 + Diamond Card 当日奖励由服务端聚合） */
export async function fetchRewardsTabStatus(): Promise<RewardsTabStatusData> {
  const { data } = await api.get<any, { data: RewardsTabStatusData }>('/interactive/rewards/tab-status')
  return data
}
